import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_HREF } from '@nrx/booking-ui';
import type { JSX } from 'react';

const SUPPORT_EMAIL = 'consults@nourishedrx.com';

/** The approved "Questions?" line: text or email support. */
export function SupportContact(): JSX.Element {
  return (
    <p className="text-[var(--ink-soft)]">
      Questions? You can text us at{' '}
      <a className="font-medium text-[var(--forest)] underline" href={SUPPORT_PHONE_HREF}>
        {SUPPORT_PHONE_DISPLAY}
      </a>
      , Monday to Friday, 8 a.m. to 8 p.m. ET, or email us at{' '}
      <a className="font-medium text-[var(--forest)] underline" href={`mailto:${SUPPORT_EMAIL}`}>
        {SUPPORT_EMAIL}
      </a>
      .
    </p>
  );
}
